import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listarVinculosBots } from './api';
import { exibirBot, mapaDeApelidos } from './utils/apelidos';

/**
 * Mapa nome→apelido COMPARTILHADO da página: mesma queryKey dos demais consumidores
 * de `/dependencias/bots` (`orqVinculosBots`) — o React Query deduplica e a página
 * inteira faz 1 fetch só, como as outras queries transversais do index.
 *
 * `apelidoDoBot(nome)` devolve o apelido ?? nome real (exibição); `temApelido(nome)`
 * diz quando vale pendurar o nome real no title/tooltip.
 */
export const useApelidos = () => {
  const { data: vinculos } = useQuery({
    queryKey: ['orqVinculosBots'],
    queryFn: () => listarVinculosBots(),
  });

  const mapa = useMemo(() => mapaDeApelidos(vinculos ?? []), [vinculos]);

  const apelidoDoBot = useCallback((bot: string): string => exibirBot(mapa, bot), [mapa]);
  const temApelido = useCallback((bot: string): boolean => mapa.has(bot), [mapa]);

  return { apelidoDoBot, temApelido };
};
